<template>
  <HeaderNotify>
    <div v-if="store.state.auth?.isVrio" class="color-blue">
      Вы работаете под учетной записью @{{ store.state.auth.me?.username }}. Для
      возврата в свою УЗ необходимо
      <button class="btn-reset btn-link" @click="logout">авторизоваться</button>
    </div>
    <div v-else-if="store.state.auth.me?.vrio?.length" class="color-red">
      Вы назначены как ВРИО
      <button class="btn-reset btn-link" @click="onOpenProxyModal">
        Подробнее
      </button>
    </div>
  </HeaderNotify>
  <header class="header">
    <HeaderNav
      v-if="store.state.auth.me?.roles"
      :roles="store.state.auth.me.roles"
    />
    <div class="header-person">
      <button @click="isMenuShow = !isMenuShow">
        <img src="@/assets/img/person.svg" />
        {{ store.state.auth.me?.name }}
      </button>
      <Dropdown v-if="isMenuShow" @close="isMenuShow = false">
        <li v-if="!isAdmin">
          <button @click="onOpenProxyModal">Установить заместителя</button>
        </li>
        <li>
          <button @click="onChangePassword">Сменить пароль</button>
        </li>
        <li>
          <button type="button" @click="logout">Выйти</button>
        </li>
      </Dropdown>
    </div>
    <div class="header-row">
      <span v-if="store.state.auth.me?.username">
        Username: <strong>{{ store.state.auth.me.username }}</strong>
      </span>
    </div>
  </header>
  <Modal v-if="isModalShow" @close="() => changeModalShow(false)">
    <template #header-all>
      <BackButton :click="() => changeModalShow(false)" type="button">
        Отмена
      </BackButton>
    </template>
    <template #content>
      <ChangePasswordForm @success="() => changeModalShow(false)" />
    </template>
  </Modal>

  <ProxyListModal v-if="isProxyModalShow" @close="isProxyModalShow = false" />
</template>

<script setup>
import router from '@/router'
import { useStore } from 'vuex'
import { ref, computed } from 'vue'
import Dropdown from '@/components/Dropdown.vue'
import Modal from '@/components/Modal.vue'
import BackButton from '@/components/BackButton.vue'
import ChangePasswordForm from '@/components/ChangePasswordForm.vue'
import ProxyListModal from '@/components/modals/ProxyListModal.vue'
import HeaderNotify from '@/components/HeaderNotify.vue'
import HeaderNav from '@/components/HeaderNav.vue'

const store = useStore()
const isModalShow = ref(false)
const isProxyModalShow = ref(false)
const isMenuShow = ref(false)

const isAdmin = computed(() =>
  store.state.auth.me?.roles?.some((r) =>
    ['adminsales', 'admintrade'].includes(r)
  )
)

/**
 * @param {boolean} payload
 */
const changeModalShow = (payload) => (isModalShow.value = payload)

const onChangePassword = () => {
  isMenuShow.value = false
  isModalShow.value = true
}

const logout = async () => {
  isMenuShow.value = false
  store.commit('auth/clearTokens')
  store.commit('auth/clearIsVrio')
  await router.push({ name: 'Auth' })
  // #3174
  // перезагружаем страницу, что бы сбросить profile, и заново расставить roles
  // реактивно сбросить не получилось, т.к. есть не реактивные roles, которые устанавливаются при первой авторизации
  location.reload()
}

const onOpenProxyModal = () => {
  isMenuShow.value = false
  isProxyModalShow.value = true
}
</script>

<style lang="scss" scoped>
.header {
  // height: 95px;
  // border-bottom: 1px solid #d2d2d2;
  // margin: 0px 15px;
  // font-size: 10px;
  // gap: 16px;
  // line-height: 1.2;
  // @include mobile {
  //   height: 63px;
  // }
  border-bottom: 1px solid #d2d2d2;
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
  justify-content: flex-end;
  gap: 8px 16px;
  font-size: 12px;
  line-height: 1.2;
  @include mobile {
    gap: 8px;
  }
  &-person {
    gap: 6px;
    font-weight: 700;
    position: relative;
    &:deep() button {
      @include reset-button;
      font-size: inherit;
      line-height: inherit;
      img {
        max-width: 24px;
        max-height: 24px;
        vertical-align: middle;
      }
    }
  }
  &-row {
    width: 100%;
    display: flex;
    gap: 16px;
    align-items: top;
    justify-content: flex-end;
    @include mobile {
      gap: 8px;
    }
  }
}
</style>
